var _ellipse, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9_3444",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.0581,
    cy: 10.6206,
    rx: 10.7046,
    ry: 10.3885,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9_3444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6581 0.232178H5.08841C2.26939 0.232178 -0.0158691 2.44996 -0.0158691 5.18573V16.4138C-0.0158691 19.1495 2.26939 21.3673 5.08841 21.3673H16.6581C19.4771 21.3673 21.7624 19.1495 21.7624 16.4138V5.18573C21.7624 2.44996 19.4771 0.232178 16.6581 0.232178Z",
    fill: "url(#paint0_radial_9_3444)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6581 0.232178H5.08841C2.26939 0.232178 -0.0158691 2.44996 -0.0158691 5.18573V16.4138C-0.0158691 19.1495 2.26939 21.3673 5.08841 21.3673H16.6581C19.4771 21.3673 21.7624 19.1495 21.7624 16.4138V5.18573C21.7624 2.44996 19.4771 0.232178 16.6581 0.232178Z",
    fill: "url(#paint1_radial_9_3444)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0586 4.52368C9.35443 4.52368 9.14051 4.53093 8.47121 4.56046C7.80316 4.59018 7.34715 4.69279 6.94818 4.84339C6.5354 4.99892 6.18532 5.20701 5.83655 5.54559C5.48746 5.88412 5.27304 6.22387 5.11228 6.62426C4.95665 7.01157 4.85079 7.45429 4.82073 8.1023C4.7908 8.75188 4.78296 8.95954 4.78296 10.6134C4.78296 12.2673 4.79049 12.4743 4.82086 13.1238C4.85161 13.7721 4.95734 14.2147 5.1124 14.6018C5.27279 15.0024 5.48721 15.3422 5.83611 15.6806C6.18481 16.0194 6.5349 16.228 6.94736 16.3835C7.34665 16.5341 7.80272 16.6367 8.47064 16.6664C9.14001 16.696 9.35374 16.7032 11.0579 16.7032C12.7622 16.7032 12.9755 16.696 13.6448 16.6664C14.3128 16.6367 14.7693 16.5341 15.1686 16.3835C15.5812 16.228 15.9308 16.0194 16.2794 15.6806C16.6285 15.3422 16.8429 15.0024 17.0037 14.602C17.1579 14.2147 17.2639 13.772 17.2952 13.1239C17.3253 12.4744 17.3331 12.2673 17.3331 10.6134C17.3331 8.95954 17.3253 8.75201 17.2952 8.10242C17.2639 7.45411 17.1579 7.01163 17.0037 6.62445C16.8429 6.22387 16.6285 5.88412 16.2794 5.54559C15.9304 5.20689 15.5813 4.9988 15.1682 4.84345C14.7682 4.69279 14.3119 4.59012 13.6439 4.56046C12.9745 4.53093 12.7614 4.52368 11.0567 4.52368H11.0586ZM10.4957 5.62111C10.6628 5.62086 10.8492 5.62111 11.0586 5.62111C12.7341 5.62111 12.9327 5.62695 13.5943 5.65612C14.2061 5.68328 14.5382 5.78248 14.7594 5.86585C15.0523 5.9762 15.261 6.10816 15.4805 6.32136C15.7002 6.5345 15.8361 6.73747 15.9501 7.02168C16.036 7.23603 16.1384 7.5583 16.1662 8.15205C16.1963 8.79402 16.2028 8.98682 16.2028 10.612C16.2028 12.2373 16.1963 12.4301 16.1662 13.072C16.1382 13.6658 16.036 13.9881 15.9501 14.2025C15.8364 14.4867 15.7002 14.689 15.4805 14.9021C15.2609 15.1152 15.0524 15.2471 14.7594 15.3575C14.5385 15.4412 14.2061 15.5402 13.5943 15.5674C12.9328 15.5965 12.7341 15.6029 11.0586 15.6029C9.38304 15.6029 9.18443 15.5965 8.52298 15.5674C7.91116 15.54 7.57908 15.4408 7.35769 15.3574C7.0649 15.247 6.85568 15.1151 6.63606 14.9019C6.41643 14.6888 6.28051 14.4863 6.16649 14.202C6.08059 13.9876 5.97824 13.6653 5.95038 13.0716C5.92032 12.4296 5.9143 12.2368 5.9143 10.6105C5.9143 8.98433 5.92032 8.7925 5.95038 8.15053C5.97836 7.55678 6.08059 7.23451 6.16649 7.01985C6.28026 6.73564 6.41643 6.53267 6.63612 6.31954C6.85575 6.1064 7.0649 5.97443 7.35775 5.86384C7.57895 5.78011 7.91116 5.68115 8.52298 5.65387C9.10185 5.62848 9.32619 5.62086 10.4957 5.61958V5.62111ZM14.4083 6.63224C13.9925 6.63224 13.6553 6.95926 13.6553 7.36276C13.6553 7.7662 13.9925 8.09353 14.4083 8.09353C14.824 8.09353 15.1613 7.7662 15.1613 7.36276C15.1613 6.95932 14.824 6.632 14.4083 6.632V6.63224ZM11.0586 7.48608C9.279 7.48608 7.83611 8.88634 7.83611 10.6134C7.83611 12.3405 9.279 13.7401 11.0586 13.7401C12.8383 13.7401 14.2807 12.3405 14.2807 10.6134C14.2807 8.88641 12.8382 7.48608 11.0585 7.48608H11.0586ZM11.0586 8.5835C12.2138 8.5835 13.1504 9.49227 13.1504 10.6134C13.1504 11.7345 12.2138 12.6434 11.0586 12.6434C9.90337 12.6434 8.96694 11.7345 8.96694 10.6134C8.96694 9.49227 9.90337 8.5835 11.0586 8.5835Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_9_3444",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.76898 22.9951) rotate(-90) scale(20.9465 20.0747)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_9_3444",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-3.66381 1.75465) rotate(78.3459) scale(9.37433 39.7226)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6600FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.86066b43dc8ef6bb4af9f8591f68150f.svg";
export { ForwardRef as ReactComponent };